import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    button: { minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328) },
    buttonText: {
        color: COLOR.BLACK,
    },
});

export default styles;
